module.exports = __webpack_public_path__ + "img/2V.1.4b854fbd.jpg";